import { getAgeIdByTitle } from '@/pages/Onboarding/options/Age/utils/getAgeIdByTitle';
import { getBodyShapeIdByTitle } from '@/pages/Onboarding/options/BodyShape/utils/getBodyShapeIdByTitle';
import { getChatInitiativeIdByTitle } from '@/pages/Onboarding/options/ChatInitiative/utils/getChatInitiativeIdByTitle';
import { getHairColorIdByTitle } from '@/pages/Onboarding/options/HairColor/utils/getHairColorIdByTitle';
import { getIdealMatchIdByTitle } from '@/pages/Onboarding/options/IdealMatch/utils/getIdealMatchIdByTitle';
import { getLonelinessIdByTitle } from '@/pages/Onboarding/options/Loneliness/utils/getLonelinessIdByTitle';
import { getMajorTurnOffIdByTitle } from '@/pages/Onboarding/options/MajorTurnOff/utils/getMajorTurnOffIdByTitle';

import { layoutDataDefault } from '../constants';
import { LayoutDataType } from '../types';

type LayoutDataTypeFromUser = Omit<
  LayoutDataType,
  | 'body_shape'
  | 'communicate'
  | 'ethnicity'
  | 'hair_color'
  | 'interaction'
  | 'major_turn_off'
  | 'obedience'
> & {
  body_shape: string;
  communicate: string;
  ethnicity: string;
  hair_color: string;
  interaction: string;
  major_turn_off: string;
  obedience: string;
};

export const normalizeOnbDataToForm = (
  onb_data: LayoutDataTypeFromUser,
): LayoutDataType => {
  return {
    ...layoutDataDefault,
    age: getAgeIdByTitle(onb_data.age),
    body_shape: getBodyShapeIdByTitle(onb_data.body_shape),
    hair_color: getHairColorIdByTitle(onb_data.hair_color),
    major_turn_off: getMajorTurnOffIdByTitle(onb_data.major_turn_off),
    personality: onb_data.personality || layoutDataDefault.personality,
    name: onb_data.name || layoutDataDefault.name,
    send_photos: onb_data.send_photos || layoutDataDefault.send_photos,
    send_videos: onb_data.send_videos || layoutDataDefault.send_videos,
    chat_initiative: getChatInitiativeIdByTitle(onb_data.chat_initiative),
    ideal_match: getIdealMatchIdByTitle(onb_data.ideal_match),
    loneliness: getLonelinessIdByTitle(onb_data.loneliness),
  };
};
